import BlazePose from "./pose-detectors/blazepose/BlazePose";
import PoseNet from "./pose-detectors/posenet/PoseNet";
import MoveNet from "./pose-detectors/movenet/MoveNet";
import BlazePoseV1 from "./blazepose";

export default class ElitePose {

    constructor(eliteService, options = {}, poseBy = 'BP') {
        console.log("poseBy", poseBy);
        this.poseDetector = null;
        switch (poseBy) {
            case "BPV1":
                this.poseDetector = new BlazePoseV1(eliteService, options);
                break;
            case "BP":
                this.poseDetector = new BlazePose(eliteService, options);
                break;
            case "OP":
                this.poseDetector = new PoseNet(eliteService, options);
                break;
            case "MN":
                this.poseDetector = new MoveNet(eliteService, options);
                break;
            case "MNBP":
                this.poseDetector = new MoveNet(eliteService, options, true);
                break;
            default:
                throw "Pose detector not supported";
        }
        return this.poseDetector;
    }
}
